import * as THREE from "three";

/**
 * 场景的逻辑分层，所有的模型均挂载在改模型下
 */
export class MLayer extends THREE.Object3D{
    
}